module.exports={render:function (){with(this) {
  return _h('time-line', {
    attrs: {
      "profile": data.profile,
      "timelines": data.timelines
    }
  })
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Main.vue
 ** module id = 25
 ** module chunks = 1
 **/